import React, { lazy } from 'react';
import RoutesEnum from 'src/enum/RoutesEnum';

export const authGuardRoutes = [
  {
    exact: true,
    path: RoutesEnum.VIEW_VEHICLE_ROUTE,
    component: lazy(() => import('src/pages/ViewVehicle')),
  },
  {
    exact: true,
    path: RoutesEnum.USERS_ROUTE,
    component: lazy(() => import('src/components/authenticate')),
  },
  {
    exact: true,
    path: RoutesEnum.DASHBOARD_ROUTE,
    component: lazy(() => import('src/pages/dashboard')),
  },
  {
    exact: true,
    path: RoutesEnum.LAST_MILE_TRACK_ROUTE,
    component: lazy(() => import('src/pages/lastMileTrack')),
  },
  {
    exact: true,
    path: RoutesEnum.REPORT_DISPATCHED_VEHICLES_ROUTE,
    component: lazy(() => import('src/pages/reportDispatchedVehicles')),
  },
  {
    exact: true,
    path: RoutesEnum.OPERATIONAL_METRICS_PAGE_ROUTE,
    component: lazy(() => import('src/pages/operationalMetricsPage')),
  },
  {
    exact: true,
    path: RoutesEnum.STOCK_PAGE_ROUTE,
    component: lazy(() => import('src/pages/stockPage')),
  },
  {
    exact: true,
    path: RoutesEnum.API_INTEGRATION_PAGE_ROUTE,
    component: lazy(() => import('src/pages/apiIntegrationPage')),
  },
  {
    exact: true,
    path: RoutesEnum.VIEW_PROFILE_ROUTE,
    component: lazy(() => import('src/pages/profilePage')),
  },
  {
    exact: true,
    path: RoutesEnum.FAQ_ROUTE,
    component: lazy(() => import('src/pages/faq')),
  },
  {
    exact: true,
    path: RoutesEnum.FAQ_SECTION_ROUTE,
    component: lazy(() => import('src/pages/faq-section')),
  },
  {
    exact: true,
    path: RoutesEnum.REQUEST_PREPARATION_LIST_ROUTE,
    component: lazy(() => import('src/pages/requestPreparation/listRequestPreparation')),
  },
  {
    exact: true,
    path: RoutesEnum.REQUEST_PREPARATION_CREATE_ROUTE,
    component: lazy(() => import('src/pages/requestPreparation/createRequestPreparation')),
  },
  {
    exact: true,
    path: RoutesEnum.VIEW_DETAILS_REQUEST_PREPARATION_ROUTE,
    component: lazy(() => import('src/pages/requestPreparation/viewDetailsRequestPreparation')),
  },
  {
    exact: true,
    path: RoutesEnum.ADMIN_REQUEST_PREPARATION_CREATE_ROUTE,
    component: lazy(() => import('src/pages/requestPreparation/createRequestPreparation')),
  },
  {
    exact: true,
    path: RoutesEnum.VIEW_SEARCH_VEHICLES_ROUTE,
    component: lazy(() => import('src/pages/searchVehiclesPage')),
  },
]